var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.185,
    cy: 18.56,
    r: 18.017,
    fill: "#3D60A2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4r1puln41a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.672 16.077v9.986a2.206 2.206 0 0 0 2.213 2.207h12.606a2.207 2.207 0 0 0 2.207-2.207v-9.986a2.213 2.213 0 0 0-2.207-2.213H23.09c.193-.2.364-.42.51-.655a3.177 3.177 0 0 0 .08-3.117 2.476 2.476 0 0 0-2.22-1.245 3.398 3.398 0 0 0-2.62 1.107 3.98 3.98 0 0 0-.655.93 3.983 3.983 0 0 0-.622-.93 3.399 3.399 0 0 0-2.62-1.107 2.488 2.488 0 0 0-2.226 1.238 3.176 3.176 0 0 0 .079 3.117c.146.236.317.456.51.655h-1.42a2.215 2.215 0 0 0-2.214 2.22zm15.716 0v9.986a.899.899 0 0 1-.897.898H18.84l.046-11.788h5.625a.904.904 0 0 1 .877.904zm-3.929-5.894a1.173 1.173 0 0 1 1.094.583 1.827 1.827 0 0 1-.085 1.807c-.282.492-1.022 1.31-2.803 1.31h-.825c0-.792.15-2.2.91-3.032a2.142 2.142 0 0 1 1.71-.694v.026zm-7.55 2.364a1.828 1.828 0 0 1-.085-1.807 1.173 1.173 0 0 1 1.087-.583 2.142 2.142 0 0 1 1.676.655c.766.851.904 2.26.943 3.052h-.819c-1.8 0-2.52-.825-2.802-1.317zm-2.927 3.53a.903.903 0 0 1 .903-.904h5.645l-.046 11.787h-5.599a.897.897 0 0 1-.903-.897v-9.986z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4r1puln41a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7.707 8.082)",
    d: "M0 0h20.955v20.955H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.49d2ba1774e7b2c2aa07302f86299882.svg";
export { ForwardRef as ReactComponent };